import { FoundDeviceModel } from 'src/Libs/installations/models/device-detector.model'

const POWER_METER_DEVICE_TYPE = 'PowerMeter'

const QNTM_DEVICE_TYPE_SUBSTRING = 'storageentity'

export const isPowerMeterFoundDevice = (device: FoundDeviceModel): boolean =>
  typeof device.type === 'string' && device.type.toLowerCase() === POWER_METER_DEVICE_TYPE.toLowerCase()

/**
 * Qntm storages are reported with device types like "StorageEntity", so the type is matched
 * via a substring check rather than an exact match (unlike isPowerMeterFoundDevice).
 */
export const isQntmFoundDevice = (device: FoundDeviceModel): boolean =>
  typeof device.type === 'string' && device.type.toLowerCase().includes(QNTM_DEVICE_TYPE_SUBSTRING)

/**
 * Looks up the IP address of the power meter with the given serial number among a set of
 * found devices, e.g. the result of the last completed device detector scan.
 */
export const findPowerMeterIpAddress = (devices: FoundDeviceModel[] | undefined, serialNumber: string | undefined): string | undefined => {
  if (!serialNumber) return undefined

  return devices?.find(device => isPowerMeterFoundDevice(device) && device.serialNumber === serialNumber)?.ipAddress
}
